import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { createSlug, LISTING_PAGE_PARAM_TYPE_DRAFT } from '../../util/urlHelpers';
import { createResourceLocatorString } from '../../util/routes';
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import { SecondaryButton } from '../../components';

import { listPieceForSale } from '../../ducks/collectionSale.duck';

import css from './ListPieceForSaleButton.module.css';

/**
 * Nextmine: samlerens vej fra "nogen er interesseret" til en rigtig handel.
 *
 * Uden den her knap er springet manuelt: opret annoncen forfra, find tråden
 * igen, send linket. Knappen laver kladden med stykkets titel, beskrivelse og
 * fotos og åbner wizarden, hvor hun kun mangler pris og de felter en vare skal
 * have. Stykket bliver i samlingen.
 *
 * @param {Object} props
 * @param {Object} props.piece samlingsstykket (skal være hendes eget)
 */
const ListPieceForSaleButton = props => {
  const { className, rootClassName, piece } = props;
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();
  const dispatch = useDispatch();

  const { listPieceInProgress, listPieceError } = useSelector(state => state.collectionSale);

  const alreadyListed = !!piece?.attributes?.publicData?.forSaleListingId;

  const handleClick = () => {
    dispatch(listPieceForSale(piece, config))
      .then(draftId => {
        const slug = createSlug(piece?.attributes?.title || '');
        history.push(
          createResourceLocatorString(
            'EditListingPage',
            routeConfiguration,
            { id: draftId.uuid, slug, type: LISTING_PAGE_PARAM_TYPE_DRAFT, tab: 'details' },
            {}
          )
        );
      })
      .catch(() => {
        // Fejlen vises herunder.
      });
  };

  return (
    <div className={classNames(rootClassName || css.root, className)}>
      <SecondaryButton
        className={css.button}
        type="button"
        onClick={handleClick}
        inProgress={listPieceInProgress}
      >
        <FormattedMessage
          id={alreadyListed ? 'ListPieceForSale.again' : 'ListPieceForSale.button'}
        />
      </SecondaryButton>
      <p className={css.hint}>
        <FormattedMessage id="ListPieceForSale.hint" />
      </p>
      {listPieceError ? (
        <p className={css.error}>
          <FormattedMessage id="ListPieceForSale.failed" />
        </p>
      ) : null}
    </div>
  );
};

export default ListPieceForSaleButton;
